module.exports = __webpack_public_path__ + "static/media/arrowExpandedIcon.0871dbea.svg";